module.exports = __webpack_public_path__ + "img/IMG_4215_L_BlackMatted.2c626a5b.jpg";